import styled, { css } from 'styled-components';

import * as Colors from '../../attrs/colors';

import SignupButton from '../signupButton';
import LoginButton from '../loginButton';

export const Container = styled.div`
  ${(props) =>
    !props.mobileDrawer &&
    css`
      padding: 0 0 0 0.5rem;
      border-left: 1px solid ${Colors.GREY_80};
    `}
`;

export const StyledLoginButton = styled(LoginButton)`
  opacity: 0.7;

  :hover,
  :focus {
    opacity: 0.85;
    color: ${Colors.BLACK};
  }

  ${(props) =>
    props.mobileDrawer &&
    css`
      opacity: 1;
      color: ${Colors.WHITE} !important;
    `}
`;

export const StyledSignupButton = styled(SignupButton)`
  margin-left: 0.5rem;

  ${(props) =>
    props.mobileDrawer &&
    css`
      :hover,
      :focus {
        color: ${Colors.WHITE};
        border-color: ${Colors.WHITE};
      }
    `}
`;
